// extracted by mini-css-extract-plugin
export default {"list":"list_list__WeZoI","list_item":"list_list_item__fjlbd"};